<template>
    <div>
        <div>
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
                出差申请-详情</div>
            <el-button
                style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                @click="Return">返回</el-button>

            <!-- 主体 -->
            <div style="height:540px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
                <!-- 查询框 -->
                <div style="margin:0 0 50px 30%">
                    <el-steps :space="200" :active="1" finish-status="success">
                        <el-step title="发起出差"></el-step>
                        <el-step title="审核中"></el-step>
                        <el-step title="审核通过"></el-step>
                    </el-steps>
                </div>
                <span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
                <span style="font-size:20px;font-weight:700">基本信息</span>
                <div style="border:1px solid #DADADA;margin-top:10px"></div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="staff_id" style="margin-top:50px">
                                {{ruleForm.staff_name}}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="出差事由" prop="evection_reason" style="width:80%">
                                {{ruleForm.evection_reason}}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div style="margin-top:50px" v-for="(item, index) in ruleForm.evectionTripList" :key="index">
                        <span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
                        <span style="font-size:20px;font-weight:700">行程{{index + 1}}</span>
                        <div style="border:1px solid #DADADA;margin-top:10px"></div>

                        <el-row style="margin-top:50px">
                            <el-col :span="6">
                                <el-form-item label="交通工具" prop="dictionaries_id">
                                    {{evectionTripList[index].dictionaries_data}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="单程往返">
                                    {{evectionTripList[index].trip_type === '1' ? "单程" : "往返"}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="出发城市">
                                    {{evectionTripList[index].start_city}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="目的城市">
                                    {{evectionTripList[index].end_city}}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="开始时间">
                                    {{evectionTripList[index].start_date}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="结束时间">
                                    {{evectionTripList[index].start_date}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="时长(小时)" style="width:80%">
                                    {{evectionTripList[index].trip_duration}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <div style="margin-top:50px">
                        <span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
                        <span style="font-size:20px;font-weight:700">同行人</span>
                        <div style="border:1px solid #DADADA;margin-top:10px"></div>

                        <el-row style="margin-top: 20px;">

                            <el-col :lg="4" :xl="2" v-for="(item, index) in together_evections" :key="index">
                                <div style="height: 36px; width: 60%; padding: 0 10%; background-color: #ebf4f1;">
                                    <span style="line-height: 36px;">{{item.staff_name}}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>

        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                //表单数据
                ruleForm: {
                    id: '',
                    staff_id: '',
                    evection_reason: '',
                    together_evection: '',
                    evectionTripList: [{
                        id: "",
                        dictionaries_id: "",
                        start_city: "",
                        end_city: "",
                        trip_type: "",
                        trip_duration: "",
                        start_date: "",
                        end_date: "",
                    }],
                    evectionTrip: {
                        id: "",
                        dictionaries_id: "",
                        start_city: "",
                        end_city: "",
                        trip_type: "",
                        trip_duration: "",
                        start_date: "",
                        end_date: "",
                    }
                },

                //表单验证
                rules: {
                    staff_id: [{
                        required: true,
                        message: '请选择员工！',
                        trigger: 'blur'
                    }],
                    evection_reason: [{
                        required: true,
                        message: '请输入出差事由！',
                        trigger: 'blur'
                    }],
                },

                //页面相关
                dialogVisible: false,

                //行程暂存
                evectionTripList: [{
                    id: "",
                    dictionaries_id: "",
                    start_city: "",
                    end_city: "",
                    trip_type: "",
                    trip_duration: "",
                    start_date: "",
                    end_date: "",
                }],

            };
        },
        methods: {
            Return() {
                this.$parent.Return();
            },
            Initialize() {

                this.evectionTripList = [];
                this.ruleForm.evectionTripList.forEach(item => {
                    this.evectionTripList.push(item);
                });

                this.together_evections = [];
                this.staffList.forEach(staff => {
                    this.ruleForm.together_evection.split(",").forEach(item => {
                        if (item != null && item != '') {
                            var id = parseInt(item);
                            if (id === staff.id) {
                                this.together_evections.push(staff);
                            }
                        }
                    })
                })
            }
        },
        async created() {
            this.ruleForm = this.$parent.ruleForm;
            // 员工下拉
            var staffList = await this.$globals.AxiosPost("staff/selectFind", {});
            this.staffList = staffList.data;
        },
    }
</script>

<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// Ccsq_edit.vue?6b4859f5